import "./css/standard-settings.css";
import "./css/accordion.css";
import "./css/detailview.css";
import "./css/bookmoede.css";
import "./css/favoritter_anden_bruger.css";
import "./css/favoritter_faelles.css";
import "./css/favoritter_modal.css";
import "./css/favoritter_oversigt.css";
import "./css/flag.css";
import "./css/kommentarer.css";
import "./css/moduler.css";
import "./css/program.css";
import "./css/tippy.css";
import "./css/toast.css";
import "./css/udstillerunivers.css";
import "./css/filter-panel.css";
import "./css/filter-panel_buttons.css";
import "./css/filter-panel_choices.css";
import "./css/filter-panel_filters.css";
import "./css/filter-panel_icons.css";
import "./css/elements.css";
import "./css/elements_masonry.css";
import "./css/elements_list.css";
import "./css/elements_map.css";
import "./css/element.css";
import "./css/element_infoboks.css";
import "./css/element_overlay.css";
import "./css/element_icons.css";
import "./css/element_grid.css";
import "./css/element_list.css";
import "./css/element_priser.css";
import "./css/element_dele_knapper.css";
import "./css/element_programstatus.css";
import "./css/element_tidspunkter.css";
import "./css/element_rute_paa_indlaeg.css";
import "./css/labels.css";
import "./css/modal-detail_view.css";
import "./css/modal-detail_view_oversigt.css";
import "./css/modal-detail_view_rute_paa_indlaeg.css";
import "./css/modal-map_view.css";
import "./css/linked-modules.css";

import "./css/gallery.css";

import "./css/swiper.css";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/thumbs";
import "swiper/css/navigation";
import "swiper/css/pagination";

import "../node_modules/choices.js/public/assets/styles/choices.min.css";

import "./fa-kit";
import "../node_modules/font-awesome/css/font-awesome.min.css";

import "../node_modules/flag-icons/css/flag-icons.min.css";

import { Main } from "./js/app/main";
import * as Log from "./js/helpers/browserConsole.js";
import { Toast } from "toaster-js";

let hasRun = false;

function run() {
  if (hasRun) {
    return;
  }

  hasRun = true;

  try {
    console.log("UG searchview warming up...");
    Main();
  } catch (e: any) {
    console.error("Fatal", e);
    if (typeof Toast !== "undefined") {
      new Toast(e, Toast.TYPE_ERROR, 5000);
    } else {
      console.error("Toast is not defined");
    }
  }
}

function checkForElementAndRun() {
  const element = document.querySelector(".ug-app");
  if (element) {
    run();
  }
}

// Use MutationObserver to watch for changes in the DOM
const observer = new MutationObserver(function (mutations) {
  checkForElementAndRun();
});

// Start observing the document with the configured parameters
observer.observe(document.body, { childList: true, subtree: true });

// Also check immediately in case the element is already present
checkForElementAndRun();

// Optionally, stop observing once the function has run
if (hasRun) {
  observer.disconnect();
}
